import { render, staticRenderFns } from "./AdminActivities.vue?vue&type=template&id=b8f63ada&"
import script from "./AdminActivities.vue?vue&type=script&lang=js&"
export * from "./AdminActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports